var Curriculog = Curriculog || {};

Curriculog.ManageUserRolesBasicView = (function ($, _, Backbone, ManageUserRolesBasicView) {

    ManageUserRolesBasicView = Curriculog.CurriculogView.extend({
        template: 'HierarchyFlyout/manageUserRolesBasic.html',

        events: {
            'click #user-role-swap': 'swapUserForUserRole',
            'click #agenda-admin': 'updateAgendaAdminStatus',
            'click #user-role-delete': 'deleteUserRole',
        },

        initialize: function (options) {
            this.user = options.user;
            this.role = options.role;
            this.users = options.users;
            this.userRole = options.userRole;
            this.committee = options.committee;
            this.agendaAdmin = options.agendaAdmin;
            this.agendaAdmins = options.agendaAdmins;
            this.canDelete = options.canDelete;

            this.listenTo(Backbone, 'update-agenda-admin', this.updateUserRoleCanDelete);
            this.listenTo(this.userRole, 'change', this.updateUserName);

            if (this.committee) {
                this.committeeName = this.committee.get('name');
            }

            this.render();
        },

        updateUserName: function () {
            userID = this.userRole.get('user_id');
            userModel = this.users.get(userID);
            sanitizedUserModel = userModel.getSanitizedModel();
            this.$el.find('#user-name').val(sanitizedUserModel.name());
        },

        render: function () {
            templateData = {
                userName: this.user.name(),
                roleName: this.role.get('name'),
                committeeName: this.committeeName,
                agendaAdmin: this.agendaAdmin,
            };

            this.el = nunjucks.render(this.template, templateData);
            this.replaceElement(this.el);

            if (this.canDelete) {
                this.$el.find('#user-role-delete').prop('disabled', false);
            }
        },

        swapUserForUserRole: function () {
            var userRole = {
                id : this.role.get('id'),
                userId: this.userRole.get('user_id'),
                name: this.role.get('name'),
                type: 'user-role'
            };

            var mask = $('#user-role-form').parent().parent();
            domObject.addLoadingMask(mask);

            accountObject.swapAccountRole(userRole, function () {
                domObject.removeMask(mask);
            });
        },

        deleteUserRole: function () {
            var view = this;

            new Curriculog.DeleteDialog({
                itemType: 'user role',
                itemName: view.role.getSanitizedModel().get('name'),
                callback: function () {

                    view.userRole.destroy({
                        wait: true,

                        beforeSend: function () {
                            mask = $('#user-role-form').parent().parent();
                            domObject.addLoadingMask(mask);
                        },
                        success: function () {
                            closeFlyout(function () {
                                mask = $('#user-role-form').parent().parent();
                                domObject.removeMask(mask);
                            });
                        },

                        error: function () {
                            mask = $('#user-role-form').parent().parent();
                            domObject.removeMask(mask);

                            var errorText = 'An error was encountered when deleting the user role.  ';
                            errorText += 'The user role has not been deleted.  Please try again '
                            errorText += 'or contact an administrator.';
                            $('#growls').notify('create', 'warning-template', {
                                text: errorText
                            });
                        },
                    });
                },

                message: function () {
                    var userID = view.userRole.get('user_id');
                    var user = view.users.get(userID);
                    var sanitizedUser = user.getSanitizedModel()

                    msg = 'Are you sure you want to remove <span class="strong">';
                    msg += sanitizedUser.name();
                    msg += '</span> ';
                    msg += 'from the <span class="strong">';
                    msg += this.itemName
                    msg += '</span> role?';
                    return msg;
                },

                buttons: function () {
                    deleteButtonText = 'Remove User From Role';

                    returnVal = {}
                    returnVal[deleteButtonText] = 'deleteCallback';
                    returnVal['Cancel'] = 'close';
                    return returnVal;
                },
            });
        },

        updateAgendaAdminStatus: function (event) {
            var checkbox = event.target;

            if (checkbox.checked === true && !this.agendaAdmin) {
                this.addAgendaAdmin();
            } else if (checkbox.checked === false && this.agendaAdmin) {
                this.removeAgendaAdmin();
            }
            // else the checkbox and the admin status match, so we don't
            // need to update anything.
        },

        updateUserRoleCanDelete: function () {
            var view = this;
            $.ajax({
                type: 'GET',
                url: 'rest/userroleflyout/' + view.userRole.get('id'),

                error: function() {

                },

                success: function (data) {
                    if (data.user_role_can_delete) {
                        view.$el.find('#user-role-delete').attr('disabled', false);
                    } else {
                        view.$el.find('#user-role-delete').attr('disabled', 'disabled');
                    }
                },
            });
        },

        removeAgendaAdmin: function() {
            var view = this;
            var committeeID = this.committee.get('id');

            if (this.agendaAdmins.getAdminsForCommittee(committeeID).length === 1) {
                this.showSwapDialog();
            } else {
                workload = {
                    method_args: {
                        userID: this.user.get('id'),
                        committeeID: committeeID,
                    }
                }

                $.ajax({
                    type: 'POST',
                    url: '/gearman-job.json',
                    contentType: 'application/json',
                    mask: $('#user-role-form').parent().parent(),
                    data: JSON.stringify({
                        functionName: 'remove_agenda_admin_task',
                        workload: workload
                    }),
                    beforeSend: function() {
                        domObject.addLoadingMask(this.mask);
                    },

                    success: function (results) {
                        getBackgroundJobStatus(results.jobHandle, this.mask, 'Remove Agenda Admin', function (jobResults) {
                            agendaAdminRecord = view.agendaAdmins.findWhere({
                                user_id: view.user.get('id'),
                                committee_id: view.committee.get('id'),
                            });
                            view.agendaAdmins.remove(agendaAdminRecord, {silent: true})
                            Backbone.trigger('update-agenda-admin');
                            view.agendaAdmin = 0;
                        },
                        function(jobResults){
              						var taskName = 'Remove Agenda Admin';
              						$('#growls').notify("create","warning-template", {
              							title: 'Warning',
              							text: 'An error occurred while attempting to ' + taskName + '. Please try again or contact a system administrator.',
              						}, {
              							expires: false,
              						});
              					}
                        );
                    },

                    error: function () {
                        domObject.removeMask(this.mask);

                        view.$el.find('#agenda-admin').prop('checked', true);

                        errorMsg = 'There was an error removing the agenda admin priveledges from ';
                        errorMsg += view.user.name();
                        errorMsg += '.  Please try again or contact an administrator.'
                        view.showGrowl(errorMsg);
                    },
                });


            }
        },

        showSwapDialog: function () {
            var view = this;

            var agendaAdmin = {
                committee : this.committee.get('id'),
                id: this.user.get('id'),
                type: 'user-agenda',
            };

            var dataParams = {
                display: 'swapUser'
            };

            var getUrl = '/admin/account:' + agendaAdmin.id + '/getCommittee';
            var putUrl = '/admin/account:' + agendaAdmin.id + '/swapAgendaAdmin.json';
            dataParams.committee = agendaAdmin.committee;

            $.ajax({
                url: getUrl,
                type: 'GET',
                data: dataParams,
                success: function(result) {
                    $('body').append(result);

                    var dialog = objDialog.createDOMWarningDialog('swap-user-dialog', function(dialog, defaults) {
                        $('.participant-picker').participantpicker(
                            {
                                'type':'swap',
                                'selectNewAgendaAdmin': true,
                                'buttonText': 'Select agenda admin',
                                'selectText': 'Select user',
                                'selectionRequired': true,
                                'dbData': ''
                            }
                        );

                        defaults.buttons = [
                            {
                                id: 'finalize-delete',
                                text: 'Swap Agenda Admin',
                                click: function() {
                                    var newAdminID = +$(this).find('.participant-picker .user')
                                                        .attr('id')
                                                        .replace('swap-user-', '');

                                    workload = {
                                        method_args: {
                                            fromUser: view.user.get('id'),
                                            committeeId: view.committee.get('id'),
                                            toUser: newAdminID,
                                        }
                                    }

                                    $.ajax({
                                        type: 'POST',
                                        url: '/gearman-job.json',
                                        contentType: 'application/json',
                                        mask: $('#user-role-form').parent().parent(),
                                        data: JSON.stringify({
                                            functionName: 'swap_agenda_admin_task',
                                            workload: workload
                                        }),
                                        beforeSend: function() {
                                            $('#finalize-delete').attr('disabled', true);

                                            domObject.addLoadingMask(this.mask);

                                            $('div.qtip-active').remove();
                                            $(dialog).dialog('close');
                                            $(dialog).remove();
                                        },

                                        success: function (results) {
                                            getBackgroundJobStatus(results.jobHandle, this.mask, 'Swap Agenda Admin', function (jobResults) {
                                                // update agendaAdmin collection
                                                agendaAdminRecord = view.agendaAdmins.findWhere({
                                                    user_id: view.user.get('id'),
                                                    committee_id: view.committee.get('id'),
                                                });

                                                agendaAdminRecord.set('user_id', newAdminID)
                                                Backbone.trigger('update-agenda-admin');
                                                view.agendaAdmin = 0;
                                            });
                                        },

                                        error: function () {
                                            domObject.removeMask(this.mask);

                                            view.$el.find('#agenda-admin').prop('checked', true);

                                            errorMsg = 'There was an error removing the agenda admin priveledges from ';
                                            errorMsg += view.user.name();
                                            errorMsg += '.  Please try again or contact an administrator.'
                                            view.showGrowl(errorMsg);
                                        },
                                    });
                                }
                            },
                            {
                                id: 'cancel-delete',
                                text: 'Cancel',
                                click: function() {
                                    $(dialog).dialog('close');
                                    $(dialog).remove();

                                    // re-check the agenda admin checkbox
                                    view.$el.find('#agenda-admin').prop('checked', true);
                                }
                            }];

                        $(dialog).dialog(defaults);
                    });


                    $('#finalize-delete').attr('disabled', true);
                },
            });
        },

        addAgendaAdmin: function() {
            var view = this;

            workload = {
                method_args: {
                    userID: this.user.get('id'),
                    committeeID: this.committee.get('id'),
                }
            }

            $.ajax({
                type: 'POST',
                url: '/gearman-job.json',
                contentType: 'application/json',
                mask: $('#user-role-form').parent().parent(),
                data: JSON.stringify({
                    functionName: 'add_agenda_admin_task',
                    workload: workload
                }),
                beforeSend: function() {
                    domObject.addLoadingMask(this.mask);
                },

                success: function (results) {
                    getBackgroundJobStatus(results.jobHandle, this.mask, 'Add Agenda Admin', function (jobResults) {
                        view.agendaAdmins.add({
                            user_id: view.user.get('id'),
                            committee_id: view.committee.get('id'),
                            agenda_admin: 1,
                        }, {silent: true});

                        Backbone.trigger('update-agenda-admin');
                        view.agendaAdmin = 1;
                    },
                    function(jobResults){
          						var taskName = 'Add Agenda Admin';
          						$('#growls').notify("create","warning-template", {
          							title: 'Warning',
          							text: 'An error occurred while attempting to ' + taskName + '. Please try again or contact a system administrator.',
          						}, {
          							expires: false,
          						});
          					});
                },

                error: function () {
                    domObject.removeMask(this.mask);

                    view.$el.find('#agenda-admin').prop('checked', false);

                    errorMsg = 'There was an error adding the agenda admin priveledges to ';
                    errorMsg += view.user.name();
                    errorMsg += '.  Please try again or contact an administrator.'
                    view.showGrowl(errorMsg);
                },
            });
        },
    });
    return ManageUserRolesBasicView;

})($, _, Backbone, Curriculog.ManageUserRolesBasicView || {});
